module.exports = {"230705006":"河东社区","230705007":"河西社区","230705008":"繁荣社区","230705009":"铁西社区","230705010":"三公里社区","230705011":"钢城社区","230705012":"松胜社区","230705013":"强达社区","230705014":"白林社区","230705015":"苔青社区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/230705.json
// module id = 833
// module chunks = 0